module.exports = __webpack_public_path__ + "img/fy_code.26ca3b5c.png";